var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr'),_vm._l((_vm.scriptures),function(aScripture,i){return _c('div',{key:`script-${i}`,staticStyle:{"margin-bottom":"10px"}},[_vm._v("\n    \""+_vm._s(aScripture.text)+"\" "),_c('strong',[_vm._v("- "+_vm._s(_vm.bookChapterVerseFix(aScripture))+" ")])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }